// extracted by mini-css-extract-plugin
module.exports = {"PurchaseAndSell":"PurchaseAndSell_PurchaseAndSell__2xI2N"};